// extracted by mini-css-extract-plugin
module.exports = {"servicesGroupWrapper":"services-overview_servicesGroupWrapper__Ok7yZ","servicesImage":"services-overview_servicesImage__yVkQk"};